import { fromJSON, toJSON } from '../json';
import logger from '../setupLogger';

/**
 * @name Storage
 * @description Singleton instance of local storage
 * @param givenPrefix prefix to add before each key to preserve namespace
 * @param global global object (window in browser)
 * @method get gets a data by ket from the storage
 * @method set sets a key value pair to the storage
 * @method remove removes a key from the storage
 * @method clear clears all data stored in the storage
 */
const Storage = (function Storage() {
  let prefix;
  let adapter;
  let logService;

  return {
    init(givenPrefix, platformLogger) {
      prefix = givenPrefix;
      return function getGobal(global) {
        if (!global.localStorage) {
          throw new Error('localStorage is not present on global scope');
        }
        adapter = global.localStorage;
        logService = platformLogger;
        logService.log('starting storage');
      };
    },
    get(key) {
      return fromJSON(adapter.getItem(`${prefix}.${key}`));
    },
    set(key, value) {
      logService.log(`setting ${key} to storage`);
      return adapter.setItem(`${prefix}.${key}`, toJSON(value));
    },
    remove(key) {
      logService.log(`removing ${key} from storage`);
      return adapter.removeItem(`${prefix}.${key}`);
    },
    clear() {
      logService.log('clearing storage');
      return adapter.clear();
    }
  };
})();

export default Storage;

// Auto start Storage
Storage.init('shuffle', logger)(window);
